import { WindowMU } from "app/types/WindowMU";

declare var window:WindowMU
const Backbone = require('backbone')

export const FornecedorItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-lista-fornecedores-item",
    tagName: "tr",
    className: "clicavel",


    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    },

    events: {
        'click td': "selecionar"
    },

    selecionar: function(e) {
        this.parent.fornecedorSelecionado(this.model);
    }

});

window.FornecedorItemView = FornecedorItemView

export const FornecedoresView = Backbone.Marionette.CompositeView.extend({
    template: "#template-lista-fornecedores",
    childView: FornecedorItemView,
    childViewContainer: "#lista-fornecedores-container",

    initialize: function(options) {
        this.app = options.app;
        this.fornecedorSelecionadoCallback = options.fornecedorSelecionadoCallback;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });
        return view;
    },

    fornecedorSelecionado: function(fornecedor) {
        if (!fornecedor || !this.fornecedorSelecionadoCallback) {
            return;
        }

        this.fornecedorSelecionadoCallback(fornecedor);

    }

})

window.FornecedoresView = FornecedoresView